import { useState } from 'react';
import "./read-more-less.css";

const ReadMoreReadLess = ({ className = 'read-more-less', buttonClassName = 'btn-read-more-less', expandLabel, collapseLabel, limit, children, }) => {

    const [isReadMoreShown, setIsReadMoreShown] = useState(false);

    if (children && children.length <= limit) return <div className={className}> {children} </div>

    const text = isReadMoreShown ? children : children && children.substr(0, limit) + '...'

    const toggleBtn = () => {
        setIsReadMoreShown(prevState => !prevState);
    }

    return (
        <div className={className}>
            {text}
            <button type="button" className={buttonClassName} onClick={toggleBtn}>
                {isReadMoreShown ? collapseLabel : expandLabel}</button>
        </div>
    )
}

export default ReadMoreReadLess